import { Component, ojs, payload, app } from "modular-openscriptjs";
import { eParse, oneOf } from "../../helpers";
import { dom, tool } from "../../fotastart";

const h = app("h");
const broker = app("broker");
const $e = app("$e");	

export default class CartQuantityForm extends Component {
	render(product, ...args) {
		return h.div(
			{ class: "container" },
			h.input({
				type: "hidden",
				class: "form-control",
				placeholder: "Product Name",
				id: "cq-product-input-id",
				value: oneOf(product?.productId, null) ?? product?.id,
			}),

			h.div(
				{ class: "d-flex" },
				h.button(
					{
						class: "btn btn-outline-primary rounded-0 rounded-start flex-fill fs-3",
						onclick: this.method("decrement"),
					},
					"-"
				),
				h.input({
					type: "number",
					min: "0",
					class: "form-control rounded-0 border-start-0 border-end-0 text-center fw-bold w-50",
					placeholder: "Quantity",
					id: "cq-product-quantity-input",
					value: oneOf(product?.quantity ?? product?.qty, 1),
				}),
				h.button(
					{
						class: "btn btn-outline-primary rounded-0 rounded-end flex-fill fs-3",
						onclick: this.method("increment"),
					},
					"+"
				)
			)
		);
	}

	$$cart = {
		itemUpdated_itemAdded: (ed, event) => {
			let data = eParse(ed);
			dom.id(data.meta.buttons?.left)?.click();
		},

		needs: {
			itemUpdateForm: (ed, event) => {
				this.showForm(ed, event);
			},
		},

		has: {
			updateError: (ed, event) => {
				let data = eParse(ed);
				const btn = dom.id(data.meta.buttons.right);

				dom.enable(btn);
				dom.put("Save", btn);
			},
		},
	};

	async showForm(ed, event) {
		let data = eParse(ed);

		let options = new tool.ModalOptions();
		options.buttons.right.text = "Save";

		options.staticBackdrop();

		let title = "Choose Quantity";
		if (data.message.has("item")) {
			title = oneOf(data.message.item?.name, title);
		}

		const { buttons } = tool.modal(
			h.h6(title),
			h.CartQuantityForm(data?.message?.item),
			options
		);

		buttons.right.button.addEventListener("click", function () {
			dom.disable(this);
			dom.put("Updating...", this);

			broker.send(
				$e.cart.needs.itemUpdate,
				payload(
					{
						item: {
							id: dom.id("cq-product-input-id")?.value,
						},
						quantity: dom.id("cq-product-quantity-input")?.value,
					},
					{
						buttons: {
							left: buttons.left.button.id,
							right: buttons.right.button.id,
						},
					}
				)
			);
		});
	}

	increment() {
		this.changeValue("+");
	}

	decrement() {
		this.changeValue("-");
	}

	changeValue(type) {
		let input = dom.id("cq-product-quantity-input");

		switch (type) {
			case "+":
				return (input.value = Number(input.value) + 1);
			case "-":
				return (input.value = Math.max(input.value - 1, 1));
		}
	}
}

ojs(CartQuantityForm);
